
import { ChangeDetectorRef, Component, OnInit, AfterViewInit } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanService } from '@app/services/plan.service';
import { AuthServiceService } from '@app/services/auth-service.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from '@app/services/toast.service';
import { Observable } from 'rxjs';
import { CompanyService } from '@app/services/company.service';
import { Countrystatedropdown } from '../interface/country-state-dropdown';
import { CountryPhoneCodes } from '../interface/country-phone-codes';
import { ToastrService } from 'ngx-toastr';
import { countries } from '../interface/country-data-store';
import { environment } from 'src/environments/environment';
interface Plan {
  name: string;
  price: number;
  duration: string;
  limits: {
    maxAdmins: number;
    maxDrivers: number;
    maxLocations: number;
    archiveRetention: string;
  };
}
@Component({
  selector: 'app-update-plan',
  templateUrl: './update-plan.component.html',
  styleUrl: './update-plan.component.scss'
})

export class UpdatePlanComponent implements AfterViewInit {
  addCP!: FormGroup;
  creditCardForm!:FormGroup
  loading = false;
  isSubmitted = false;
  imageSrc: any = 'assets/images/profilephoto.png';
  userTimezone: any;
  public countries: any = countries;

  planItems: any;
  planCount: any;
  selectedGroup: string= 'yes';
  autoReneu:any;
  selectedIndex: any;
  token:any;
  plans$!: Observable<object[]>;
  isShowPlanSection: boolean= true;
  loader: boolean= true;
  selectedPaymentMode: any= 'card';
  companyId: any;
  companyData: any;
  countryCodes: any = CountryPhoneCodes;
  countrystates:any=Countrystatedropdown
  isEditMode: boolean= false;
  selectedOption: any;
  planDetails:boolean=false;
  isSidebarClosed: boolean = false;
  amount:any;
  planName:any;
  handler: any;
  autoStore:any;
  owner_first_name:any;
  owner_last_name:any;
  first_name:any;
  last_name:any;
  isEdit:boolean=false;
  stripePromise: Promise<any> | undefined;
  cardElement: any;
  elements: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public planService: PlanService,
    public authService: AuthServiceService,
    public companyService: CompanyService,
    private toastr: ToastrService,
    private activatedRouter: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private dialog: MatDialog,
    
   
  ) {
    this.addCP = formBuilder.group({
      logo: [{ value: '', disabled: true }],
      name: [{ value: '', disabled: true }, [Validators.required]],
      address: [{ value: '', disabled: true }, [Validators.required]],
      country: [{ value: '', disabled: true }, [Validators.required]],
      state: [{ value: '', disabled: true }, [Validators.required]],
      city: [{ value: '', disabled: true }, [Validators.required]],
      postal_code: [{ value: '', disabled: true }, [Validators.required]],
    
      owner_full_name: [{ value: '', disabled: true }, [Validators.required]],
      owner_phone_no: [
        { value: '', disabled: true },
        [
          Validators.required,
          Validators.pattern('^((\\+1-?)|0)?[0-9]{10}$'),
        ],
      ],
      owner_email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      are_you_admin: [{ value: 'True',disabled: true  }, [Validators.required]],
      first_name: [{ value: '', disabled: true }],
      phone_number: [{ value: '', disabled: true }],
      admin_email: [{ value: '', disabled: true }, [Validators.email]],
      description: [{ value: '', disabled: true }],
      country_code: [{ value: '', disabled: true }],
      admin_country_code: [{ value: '', disabled: true }],
    });
    
    this.addCP.get('country')?.valueChanges.subscribe(value => {
      this.adjustFieldsBasedOnCountry(value);
    });
    
    this.creditCardForm = this.formBuilder.group({
      username: ['', Validators.required],
      cardNumber: ['', Validators.required],
      expirationMonth: ['', Validators.required],
      expirationYear: ['', Validators.required],
      cvv: ['', Validators.required],
      autorenew:[],
      autostore:[],
      is_trial:[],
    });
  }
  updateNames(): void {
    const fullName = this.addCP.get('owner_full_name')?.value;
    const names = fullName.split(' ');
    this.owner_first_name=names[0];
    this.owner_last_name=names.slice(1).join(' ')||'';
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.addCP.controls;
  }
  get g(){
    return this.creditCardForm.controls;
  }

  // convenience getter for easy access to form values
  get frmValues() {
    return this.addCP.value;
  }
  cCode:any;
  ngOnInit(): void {
    // this.stripePromise = loadStripe('pk_test_51OI3lgSGmsmXN9Ul6KUMGH0Vbm4T3joNWKTlTs0uq25gu5TuCZ9S2GOVcePAXxBhAqId4tbs4lNmLL70XZ8dWwMW00DCVt3gPa');
    
    this.planList();
    this.getUserCountry();
    this.companyId= this.activatedRouter.snapshot.paramMap.get('id');
    if(this.companyId){
      this.isEditMode= true;
    
      this.getCompanyDetails();
    }
     this.isSidebarClosed = Boolean(localStorage.getItem('isHide'));

     localStorage.setItem('addcompany','true');

     console.log(this.countryCodes.value)
     this.loadStripeScript();
  }
  loadStripeScript(): Promise<void> {
  return new Promise((resolve) => {
    if ((<any>window).Stripe) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v2/';
    script.onload = () => {
      (<any>window).Stripe.setPublishableKey(environment.stripeKey);
      resolve();
    };
    document.head.appendChild(script);
  });
}
    async ngAfterViewInit() {
      // setTimeout(() => {
      //   this.paymentMode('card');
      // }, 2000);
      // Do not mount Stripe here, mount only when payment mode is 'card' and element is visible
    }

    async mountStripeCardElement() {
      const stripe = await this.stripePromise;
      if (!stripe) return;
      if (!document.getElementById('card-element')) return;
      if (this.cardElement) return; // Prevent double mounting
      this.elements = stripe.elements();
      this.cardElement = this.elements.create('card');
      this.cardElement.mount('#card-element');
    }
  getUserCountry() {
    this.http.get<any>('https://ipapi.co/json/').subscribe(
      (response) => {
        // Get the country code from the response
        const userCountryCode = response.country;
        // Find the country object in the array using the country code
        const userCountry = this.countryCodes.find((country: { code: any; }) => country.code === userCountryCode);
        if (userCountry) {
          // Set the country code in the form control
          this.addCP.patchValue({
            country_code: userCountry.dial_code,
            admin_country_code:userCountry.dial_code
          });
        }
      },
      (error) => {
        console.error('Error getting user country:', error);
        // Handle error
      }
    );
  }
  adjustFieldsBasedOnCountry(country: string) {
    this.clearAllValidators();
    if (country === 'Canada') {
      this.addCP.get('city')?.setValidators([Validators.required]);
      this.addCP.get('state')?.setValidators([Validators.required]);
      this.addCP.get('postal_code')?.setValidators([Validators.required]);
      this.addCP.get('city')?.updateValueAndValidity();
      // this.addCP.get('state')?.clearValidators();
    //  this.addCP.get('zipcode')?.clearValidators();
    //  this.addCP.get('city')?.clearValidators();
    } else if (country === 'United States') {
      this.addCP.get('state')?.setValidators([Validators.required]);
      this.addCP.get('postal_code')?.setValidators([Validators.required]);
      this.addCP.get('city')?.clearValidators();
      this.addCP.get('city')?.updateValueAndValidity();
      //  this.addCP.get('state')?.clearValidators();
    //  this.addCP.get('zipcode')?.clearValidators();
      this.addCP.get('state')?.updateValueAndValidity();
    }else if (country === '' || country == null) {
      this.addCP.get('state')?.setValidators([Validators.required]);
      this.addCP.get('city')?.setValidators([Validators.required]);
      this.addCP.get('postal_code')?.setValidators([Validators.required]);
      this.addCP.get('city')?.updateValueAndValidity();
    } 
    else {
      this.addCP.get('state')?.setValidators([Validators.required]);
      this.addCP.get('city')?.setValidators([Validators.required]);
      this.addCP.get('postal_code')?.setValidators([Validators.required]);
      this.addCP.get('city')?.updateValueAndValidity();
      // this.addCP.get('province').clearValidators();
      // this.addCP.get('postalCode').clearValidators();
    }
  }
  clearAllValidators() {
    // Clear all validators for fields that might be set
    this.addCP.get('canadacity')?.clearValidators();
    this.addCP.get('canadaprovince')?.clearValidators();
    this.addCP.get('canadapostalCode')?.clearValidators();
    this.addCP.get('usastate')?.clearValidators();
    this.addCP.get('usazipcode')?.clearValidators();
    this.addCP.get('state')?.clearValidators();
    this.addCP.get('city')?.clearValidators();
    this.addCP.get('zipcode')?.clearValidators();
  }
  updateFormControls() {
    // Update the value and validity of all relevant form controls
    this.addCP.get('canadacity')?.updateValueAndValidity();
    this.addCP.get('canadaprovince')?.updateValueAndValidity();
    this.addCP.get('canadapostalCode')?.updateValueAndValidity();
    this.addCP.get('usastate')?.updateValueAndValidity();
    this.addCP.get('usazipcode')?.updateValueAndValidity();
    this.addCP.get('state')?.updateValueAndValidity();
    this.addCP.get('city')?.updateValueAndValidity();
    this.addCP.get('zipcode')?.updateValueAndValidity();
  }
  getCompanyDetails(){
    this.loader =true;
    this.companyService.companyDetail(this.companyId).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        this.companyData= data?.results;
        this.selectedCountry = this.companyData?.organization?.company?.country;
        this.onCountryChange()
        setTimeout(()=>{
         
          this.planDetails =true;
          this.selectedIndex= this.companyData?.organization?.current_plan?.id;
          //please uncomment below line
         // this.selectPlan(this.selectedIndex);
          console.log(this.companyData.organization,'apidata');
          const ownerName=this.companyData?.organization?.company?.owner_first_name + " " + this.companyData?.organization?.company?.owner_last_name
          const areYouAdmin = this.companyData?.organization?.company?.are_you_admin;
          if (!areYouAdmin) {
            this.selectedGroup = 'False';
            this.addCP.patchValue({
              first_name: this.companyData?.admin?.first_name,
              admin_country_code:this.companyData?.admin?.country_code,
              phone_number:this.companyData?.admin?.phone_number,
              admin_email:this.companyData?.admin?.email,
            })
        }

        this.addCP.patchValue({
          
          name: this.companyData?.organization?.company?.name,
          imageSrc:this.companyData?.organization?.company?.logo,
          address: this.companyData?.organization?.company?.address,
          owner_full_name:ownerName,
          owner_phone_no:this.companyData?.organization?.company?.owner_phone_no,
          country_code:this.companyData?.organization?.company?.country_code,
          owner_email:this.companyData?.organization?.company?.owner_email,
          are_you_admin:this.companyData?.organization?.company?.are_you_admin,
          type:this.companyData?.organization?.current_plan?.type,
          country: this.companyData?.organization?.company?.country,
          state: this.companyData?.organization?.company?.state,
          city: this.companyData?.organization?.company?.city,
          postal_code:this.companyData?.organization?.company?.postal_code,
          // description: this.companyData?.organization?.company?.description,
          // admin_email: this.companyData?.organization?.company?.admin_email,
          // plan_id: this.companyData?.organization?.current_plan?.id,
          // first_name: this.companyData?.admin?.first_name,
          // phone_number: this.companyData?.organization?.company?.phone,
          // password: this.companyData?.organization?.company?.name,
         // logo: '',
        })
        this.imageSrc=this.companyData?.organization?.company?.logo ||'assets/images/profilephoto.png'
        this.selectedOption = this.companyData?.organization?.current_plan?.id;
        this.selectPlan( this.selectedOption);
        },800)
        // setTimeout(() => {
          
        //   this.cCode= this.companyData?.organization?.company?.country_code;
        //   document.getElementsByClassName('selected-dial-code')[0].innerHTML= this.cCode;
        //   let flagElt= document.getElementsByClassName('iti-flag');
        //   flagElt[0].classList.remove('ca')
        //   let cName = this.countryCodes.filter((elt:any)=>{
        //     if(elt.dial_code == this.cCode){
        //       this.loader =false;
        //       return elt
        //     }
        //   })
        //   flagElt[0].classList.add(cName[0]?.code.toLowerCase());
        //   this.addCP.patchValue({
        //     owner_phone_no:this.companyData?.organization?.company?.owner_phone_no,
        //   })
        // }, 2000);
      //  this.planList()
        
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

update(){
  if(this.addCP.invalid){
    this.isSubmitted=true;
    return
  }
  this.updateNames()
  this.loader=true;
  const formData = new FormData();
  for (let i in this.addCP.value) {
    if (this.addCP.value[i] instanceof Blob) {
      formData.append(i, this.addCP.value[i]);
    }else if (i === 'admin_email' && this.addCP.value['are_you_admin'] === true) {
      formData.append('admin_email', this.addCP.value['owner_email']);
    } 
     else {
      formData.append(i, this.addCP.value[i]);
    }
  }
  formData.append('plan_id', this.selectedIndex)

  this.userTimezone = this.authService.getLS('user_timezone');
  formData.append('user_timezone', this.userTimezone);
  formData.append('last_name', '');
  formData.append('owner_first_name',  this.owner_first_name);
  formData.append('owner_last_name',  this.owner_last_name);
  // formData.append('country_code', this.country_codess ||this.cCode);
  console.log(formData);
  this.companyService.companyAdd(formData, this.companyId).subscribe(
    (data: any) => {
      if (this.authService.resultCodeError(data)) {
        this.loader =false;
        this.loading = false;
        return;
      }
      if(this.isEditMode){
        this.toastr.success("Company Updated Successfully");
        this.loader =false;
        this.router.navigate([
          '/' + this.authService._isRoleName + '/dashboard',
        ]);
        return;
      
      }
      if(!this.isEditMode){
        this.toastr.success("Company Added Successfully");
        this.loader =false;
      }
      this.router.navigate([
        '/' + this.authService._isRoleName + '/dashboard',
      ]);
    },
    (error) => {
      this.authService.dataError(error);
      this.loading = false;
      this.loader =false;
    }
  );
}
  planList() {
    //this.loader= true;
    this.planService.planList();
    this.plans$ = this.planService.getPlans();

    this.plans$.subscribe((data: any) => {
      setTimeout(()=>this.loader= false , 1000)
      this.planItems = data?.results;
      this.planCount = data?.count;
    }, (err:any)=>{
      this.loader= false;
    });
  }

  choosePlan(id: Number) {
    this.selectedIndex = id;
  }

  paymentMode(val:any){
    this.selectedPaymentMode= val;
    setTimeout(() => {
      if (val === 'card') {
        this.mountStripeCardElement();
      }
    }, 0);
  }

  showPlanSection(){
    this.isSubmitted = true;

    // stop here if form is invalid
    if (this.addCP.invalid) {
      return;
    }
    this.isShowPlanSection= true;
    this.planList();

  }
  country_codess:any;
  getCountryCode(){
    let country_code = document.getElementsByClassName('selected-dial-code')[0].innerHTML;
    this.addCP.patchValue({
      country_code: country_code
    })
    this.country_codess =country_code
  }
  isLoading:boolean=false;
  handleSubmit() {
    this.isLoading = true; // Disable button and show loading indicator
    this.loader = false;
    
    this.updateNames();
    this.showPlanSection();
    this.click();
    
    if (this.addCP.invalid) {
      this.isSubmitted = true;
      this.isLoading = false; // Enable button if form is invalid
      this.loader = false;
      return;
    }
  
    const formData = new FormData();
    for (let i in this.addCP.value) {
      if (this.addCP.value[i] instanceof Blob) {
        formData.append(i, this.addCP.value[i]);
      } else {
        formData.append(i, this.addCP.value[i]);
      }
    }
    formData.append('payment_mode', this.selectedPaymentMode);
    formData.append('plan_id', this.selectedIndex);
    this.userTimezone = this.authService.getLS('user_timezone');
    formData.append('user_timezone', this.userTimezone);
    formData.append('last_name', '');
    formData.append('owner_first_name', this.owner_first_name);
    formData.append('owner_last_name', this.owner_last_name);
    // formData.append('is_trial','False');
  
    if (this.selectedPaymentMode !== 'cash') {
      formData.append('card_number', this.creditCardForm.get('cardNumber')?.value);
      formData.append('exp_month', this.creditCardForm.get('expirationMonth')?.value);
      formData.append('exp_year', this.creditCardForm.get('expirationYear')?.value);
      formData.append('cvc', this.creditCardForm.get('cvv')?.value);
      formData.append('card_holder_name', this.creditCardForm.get('username')?.value);
      formData.append('is_card_data_stored', this.autoStore || 'False');
      formData.append('is_auto_renewal',this.autoReneu || 'False');
      formData.append('is_trial', this.is_trial || 'False');
      formData.append('token', this.token);
      const schema_name = this.authService.getLS('schema_name') || '';
      formData.append('schema_name',schema_name);
  
      this.companyService.updatePlanUsingCard(formData, this.companyId).subscribe(
        (data: any) => {
          this.isLoading = false; // Enable button after API response
          if (this.authService.resultCodeError(data)) {
            return;
          }
          const subscriptionstatus =localStorage.getItem('subscription_status');
          const OtpLogin =localStorage.getItem('OtpLogin');
          const orderlistupdateplan = localStorage.getItem('orderlistupdateplan')
          if(subscriptionstatus ==='expired'  && OtpLogin == 'false'){
            this.toastr.success(data.resultDescription);
            this.router.navigate(['/login']);
            setTimeout(() => {
               localStorage.removeItem('subscription_status');
            }, 200);
          }
          else if(subscriptionstatus ==='expired'  && OtpLogin == 'true'){
            this.toastr.success(data.resultDescription);
            this.router.navigate(['/otplogin']);
            setTimeout(() => {
               localStorage.removeItem('subscription_status');
            }, 200);
          }
            else if(orderlistupdateplan ==='True'){
            this.toastr.success(data.resultDescription);
            this.router.navigate(['/admin/dashboard']);
          }
          else{
            this.toastr.success(data.resultDescription);
            this.router.navigate(['/admin/profile']);
          }
          // if (this.isEditMode) {
          //   this.toastr.success(data.resultDescription);
          //   this.router.navigate(['/login']);
          //   setTimeout(() => {
          //      localStorage.removeItem('subscription_status');
          //   }, 200);

          // } else {
          //   this.toastr.success("Company Added Successfully");
          // }
          //this.router.navigate(['/' + this.authService._isRoleName + '/dashboard']);
        },
        (error) => {
          this.isLoading = false; // Enable button in case of error
          this.authService.dataError(error);
        }
      );
    } else {
      this.companyService.updatePlanUsingCard(formData, this.companyId).subscribe(
        (data: any) => {
          this.isLoading = false; // Enable button after API response
          if (this.authService.resultCodeError(data)) {
            return;
          }
          if (this.isEditMode) {
            this.toastr.success("Company Updated Successfully");
          } else {
            this.toastr.success("Company Added Successfully");
          }
          //this.router.navigate(['/' + this.authService._isRoleName + '/dashboard']);
        },
        (error) => {
          this.isLoading = false; // Enable button in case of error
          this.authService.dataError(error);
        }
      );
    }
  }
  

  readURL(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      const reader = new FileReader();
      // reader.onload = (e) => {
      //   // this.cropImage('250ms','250ms',event);
      // };
      reader.onload = (e) => (this.imageSrc = reader.result);
      this.addCP.patchValue({
        logo: file,
      });

      reader.readAsDataURL(file);
    }
  }
  // cropImage(
  //   enterAnimationDuration: string,
  //   exitAnimationDuration: string,
  //   event:any
  // ): void {
  //   const dialogRef= this.dialog.open(DialogAnimationsComponent, {
  //     width: '500px',
  //     enterAnimationDuration,
  //     exitAnimationDuration,
  //     data: {
  //       btns: ['Crop','Cancel'],
  //       pageName: 'crop-image',
  //       image: event
  //     },
  //   });
  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     if(dialogResult){
  //       this.imageSrc= dialogResult.croppedImage.base64;
  //       this.addCP.patchValue({
  //         logo: dialogResult.croppedImage.file,
  //         // image: dialogResult.croppedImage.file,
  //       });
  //     }
  //   });
  // }
  IsAdmin(event:any){
    const adminNameControl = this.addCP.get('first_name');
    const ownerEmailControl = this.addCP.get('admin_email');
    const phonenumber = this.addCP.get('phone_number');
    if (event.target.checked){
      this.selectedGroup='True';
        // If isAdmin is 'yes', make adminName optional
        adminNameControl?.setValidators([]);
        ownerEmailControl?.setValidators([Validators.email]);
        phonenumber?.setValidators([]);

    }
    else if (event.target.checked == false){
      this.selectedGroup='False';
      adminNameControl?.setValidators([Validators.required]);
      ownerEmailControl?.setValidators([Validators.required, Validators.email]);
      phonenumber?.setValidators([Validators.required]);
    }
    adminNameControl?.updateValueAndValidity();
    ownerEmailControl?.updateValueAndValidity();
    phonenumber?.updateValueAndValidity();
 }
//  autoRenew(event:any){
//   if (event.target.checked){
//     this.autoReneu='True';

//   }
//   else if (event.target.checked == false){
//     this.autoReneu='False';
//   }
//   this.creditCardForm.get('autorenew')?.setValue(event.target.checked);
//  }
//  autoStoreCard(event:any){
//   if (event.target.checked){
//     this.autoStore='True';

//   }
//   else if (event.target.checked == false){
//     this.autoStore='False';
//   }
//   this.creditCardForm.get('autostore')?.setValue(event.target.checked);
//  }
autoRenewAndStoreCard(event: any) {
  if (event.target.checked) {
    this.autoReneu = 'True';
    this.autoStore = 'True';
  } else if (event.target.checked == false) {
    this.autoReneu = 'False';
    this.autoStore = 'False';
  }
  this.creditCardForm.get('autorenew')?.setValue(event.target.checked);
  this.creditCardForm.get('autostore')?.setValue(event.target.checked);
}
// This method is called when the "Start Trial Period for $1" checkbox is changed
startTrial = true; 
autoReneus=false;
is_trial:any;
onTrialChange(event: any) {
  if (event.target.checked) {
    this.startTrial =false;
    // If trial is selected, auto-renew and store card checkboxes are selected too
    this.is_trial ='True';
    this.autoReneu = 'True';
    this.autoStore = 'True';
    this.autoReneus =true
  } else {
    // If trial is deselected, reset auto-renew and store card checkboxes
    this.startTrial =true;
    this.is_trial ='False';
    this.autoReneu = 'False';
    this.autoStore = 'False';
    this.autoReneus =false;
  }

  // Update the reactive form controls based on the checkbox state
  this.creditCardForm.get('autorenew')?.setValue(event.target.checked); 
  this.creditCardForm.get('autostore')?.setValue(event.target.checked);
  this.creditCardForm.get('is_trial')?.setValue(event.target.checked);
}
 planDetailss: any; // This will store the selected plan details

 selectPlan(selectedItemId: any){
  this.planDetails=true
  this.selectedIndex = selectedItemId;
  this.planDetailss = this.planItems.find((item: { id: any; }) => item.id === Number(selectedItemId));
  this.amount=(this.planDetailss.price);
  console.log(this.amount);
  this.planName=this.planDetailss.title;
 }
 click(){
  if (this.creditCardForm.invalid) {
    return;
  }

 }
  // async getcardToken() {
  //   const stripe = await this.stripePromise;
  //   if (!stripe || !this.cardElement) {
  //     this.toastr.error('Stripe or card element not loaded');
  //     return;
  //   }
  //   console.log(this.cardElement,'cardelement');
  //   const { token, error } = await stripe.createToken(this.cardElement);
  //   if (error) {
  //       this.isSubmitted =true;
  //     this.toastr.error(error.message);
  //   } else {
  //     this.token = token.id;
  //     this.handleSubmit();
  //   }
  // }
   async getcardToken() {
  if (this.creditCardForm.valid) {
    try {
      const response = await new Promise<any>((resolve, reject) => {
        (<any>window).Stripe.createToken({
          name: this.creditCardForm.value.username,
          number: this.creditCardForm.value.cardNumber,
          exp_month: this.creditCardForm.value.expirationMonth,
          exp_year: this.creditCardForm.value.expirationYear,
          cvc: this.creditCardForm.value.cvv,
        }, (status: number, response: any) => {
          if (status === 200) { 
            resolve(response);
          } else {
            reject(new Error('Token creation failed'));
            this.toastr.error(response.error.message);
          }
        });
      });

      this.token = response.id;

      console.log(response.id);
     this.handleSubmit();
    } catch (error) {
      console.error(error);
      
      // Handle error as needed
    }
  } else {
    this.isSubmitted = true;
  }
}
onWheel(event: any) {
  event.preventDefault(); // Prevent the default behavior of the mouse wheel
}
onKeyPress(event: KeyboardEvent) {
  if ((event.target as HTMLInputElement).value.length === 16) {
    event.preventDefault(); // Prevent further input when the length is already 10
  }
}
onKeyPress1(event: KeyboardEvent) {
  if ((event.target as HTMLInputElement).value.length === 2) {
    event.preventDefault(); // Prevent further input when the length is already 10
  }
}
onKeyPress2(event: KeyboardEvent) {
  if ((event.target as HTMLInputElement).value.length === 3) {
    event.preventDefault(); // Prevent further input when the length is already 10
  }
}
onKeyPress3(event: KeyboardEvent) {
  if ((event.target as HTMLInputElement).value.length === 10) {
    event.preventDefault(); // Prevent further input when the length is already 10
  }
}

navigateToDashboard() {
  const subscriptionstatus =localStorage.getItem('subscription_status');
  const OtpLogin =localStorage.getItem('OtpLogin');
  const orderlistupdateplan = localStorage.getItem('orderlistupdateplan')
  if (subscriptionstatus === 'expired' && OtpLogin == 'false') {
    this.router.navigate(['login']);
  } else if (subscriptionstatus === 'expired' && OtpLogin == 'true') {
    this.router.navigate(['otplogin']);
  } else if (orderlistupdateplan === 'True') {
    this.router.navigate(['admin/dashboard']);
  }
   else {
    this.router.navigate(['admin/profile']);
  }
  
}
 
navigateToCreatePlan() {
  const subscriptionstatus =localStorage.getItem('subscription_status');
  if(subscriptionstatus ==='expired'){
    this.router.navigate(['create-plan']);
  }
  else  {
    this.router.navigate(['admin/create-plan']);
  }
}
selectedCountry: any ="";
states: any[] = [];
onCountryChange() {
  const selected = this.countrystates.find(
    (    country: { name: any; }) => country.name === this.selectedCountry
  );
  this.states = selected ? selected.states : [];
}
}
